export async function reportErrorToServer(errorDetails) {
  try {
    const response = await fetch("/wp-json/provider/v1/log-client-error", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": window.userInfo.nonce
      },
      body: JSON.stringify(errorDetails)
    });

    if (!response.ok) {
      console.error("Failed to report error to server:", response.statusText);
    }
  } catch (err) {
    console.error("Network error while reporting error:", err);
  }
}
